import { createContext, useContext } from "react";

import { gGateway } from "@utils/gateway";

import type { ApiClient} from "../../../utils/api/_makeApiClient";
import { makeApiClient } from "../../../utils/api/_makeApiClient";

const ApiClientContext = createContext<ApiClient>(
  window.location.hostname.includes("preview")
    ? makeApiClient(
        (url, requestInit) =>
          new Request(
            gGateway(
              url.replace(
                "api-webproever.gyldendal.dk",
                "api-preview-webproever.gyldendal.dk",
              ),
            ),
            requestInit,
          ),
      )
    : makeApiClient(
        (url, requestInit) => new Request(gGateway(url), requestInit),
      ),
);

export function useApiClient(): ApiClient {
  return useContext(ApiClientContext);
}
